var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconInfo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.46929 3.05939C9.46929 4.19561 10.3577 5.10458 11.4681 5.10458C12.5924 5.10458 13.453 4.19561 13.453 3.05939C13.453 1.90897 12.5924 1 11.4681 1C10.3577 1 9.46929 1.90897 9.46929 3.05939ZM6 21.8354C6 22.5313 6.48582 23 7.2215 23H16.7785C17.5142 23 18 22.5313 18 21.8354C18 21.1536 17.5142 20.685 16.7785 20.685H13.2076L13.2076 9.61158C13.2076 8.84463 12.7218 8.33333 12 8.33333H7.59982C6.87803 8.33333 6.37832 8.78782 6.37832 9.46955C6.37832 10.1797 6.87803 10.6484 7.59982 10.6484H10.6397L10.6397 20.685H7.2215C6.48582 20.685 6 21.1536 6 21.8354Z",
    fill: "white",
    fillOpacity: 0.85
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconInfo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-info.6740452e49d399227334bd3ea26e1ee6.svg";